import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { JobBoard } from '../../models/job-sourcing';

@Component({
  selector: 'mj-checkout-form',
  templateUrl: './checkout-form.template.html',
  styleUrls: ['./checkout-form.style.scss'],
})
export class CheckoutFormComponent {
  ordered_boards: JobBoard[];

  constructor(
    public dialogRef: MatDialogRef<CheckoutFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.ordered_boards = data.ordered_boards;
    if (!this.ordered_boards.length) {
      dialogRef.close({
        confirmed: true,
        confirmedBoards: this.ordered_boards,
      });
    }
  }

  public postOrder() {
    this.dialogRef.close({
      confirmed: true,
      confirmedBoards: this.ordered_boards,
    });
  }

  public goBack() {
    this.dialogRef.close({
      confirmed: false,
      confirmedBoards: [],
    });
  }
}
